<template>
  <div class="site-page site-page--download nav-content-inset">
  <div class="download-app-page">
    <div class="hero-section">
      <div class="hero-content">
        <h1>下载 CoolPeople APP</h1>
        <p>随时随地与优秀的人建立联系，分享您的经历，发现新机遇</p>
        
        <div class="app-preview">
          <img :src="appImage" alt="CoolPeople APP" class="app-screenshot">
        </div>
        
        <p class="download-note">手机安装包还在准备。现在用手机浏览器打开 coolpeople.com.cn，就能使用测评、课程和交友。</p>
      </div>
    </div>
    
    <div class="features-section">
      <h2>APP 功能特色</h2>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-users"></i>
          </div>
          <h3>社区互动</h3>
          <p>与来自世界各地的优秀人才建立联系，分享经验和见解</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-blog"></i>
          </div>
          <h3>内容创作</h3>
          <p>发布博客文章，分享您的专业知识和生活感悟</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-search"></i>
          </div>
          <h3>智能匹配</h3>
          <p>基于兴趣和技能，智能推荐志同道合的朋友</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-mobile-alt"></i>
          </div>
          <h3>移动优先</h3>
          <p>专为移动设备优化，随时随地享受流畅体验</p>
        </div>
      </div>
    </div>
    
    <div class="qr-section">
      <h2>先用网页</h2>
      <p class="qr-description">安装包上线后，这里会放下载入口。在此之前不会弹出「即将上线」。</p>
    </div>
  </div>
  </div>
</template>

<script>
import appImage from '@/assets/app.png'

export default {
  name: 'DownloadAppView',
  data() {
    return {
      appImage: appImage
    }
  },
}
</script>

<style scoped>
.download-app-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.hero-section {
  padding: 80px 20px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-content p {
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.7;
}

.app-preview {
  margin: 40px 0;
}

.app-screenshot {
  width: 200px;
  height: 385px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
}

.app-screenshot:hover {
  transform: scale(1.05);
}

.download-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 40px;
}

.download-btn {
  display: flex;
  align-items: center;
  padding: 15px 30px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  text-decoration: none;
  color: white;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.download-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.download-btn i {
  font-size: 2rem;
  margin-right: 15px;
}

.btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.btn-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 2px;
}

.btn-subtitle {
  font-size: 0.9rem;
  opacity: 0.8;
}

.features-section {
  padding: 80px 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.features-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 50px;
  font-weight: 700;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 20px;
  color: #ffd700;
}

.feature-card h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.feature-card p {
  opacity: 0.9;
  line-height: 1.6;
}

.qr-section {
  padding: 80px 20px;
  text-align: center;
}

.qr-section h2 {
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: 700;
}

.qr-container {
  max-width: 400px;
  margin: 0 auto;
}

.qr-code {
  background: white;
  padding: 30px;
  border-radius: 15px;
  margin-bottom: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}

.qr-placeholder i {
  font-size: 4rem;
  margin-bottom: 15px;
  color: #666;
}

.qr-placeholder p {
  font-size: 1.1rem;
  font-weight: 600;
}

.qr-description {
  opacity: 0.9;
  font-size: 1.1rem;
}

@media (max-width: 767px) {
  .hero-section {
    padding: 48px 16px 40px;
    padding-top: calc(48px + env(safe-area-inset-top, 0px));
  }

  .hero-content h1 {
    font-size: 1.75rem;
    line-height: 1.3;
  }

  .hero-content p {
    font-size: 1rem;
    margin-bottom: 28px;
  }

  .app-preview {
    margin: 24px 0;
  }

  .app-screenshot {
    width: 140px;
    height: auto;
    max-height: 270px;
    object-fit: contain;
  }

  .download-buttons {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: 28px;
    padding: 0 4px;
  }

  .download-btn {
    width: 100%;
    max-width: none;
    justify-content: center;
    padding: 14px 20px;
  }

  .features-section {
    padding: 48px 16px;
  }

  .features-section h2 {
    font-size: 1.5rem;
    margin-bottom: 28px;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .feature-card {
    padding: 20px 16px;
  }

  .feature-icon {
    font-size: 2.25rem;
  }

  .feature-card h3 {
    font-size: 1.2rem;
  }

  .qr-section {
    padding: 48px 16px calc(48px + env(safe-area-inset-bottom, 0px));
  }

  .qr-section h2 {
    font-size: 1.5rem;
    margin-bottom: 24px;
  }

  .qr-container {
    max-width: 100%;
    padding: 0 8px;
  }

  .qr-code {
    padding: 20px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .hero-content h1 {
    font-size: 2.75rem;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
